import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Badge } from 'react-bootstrap';
import StudentSteps from '../common/StudentSteps';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as coursesActions from '../../actions/coursesActionCreators';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import GetStartedForm from './GetStartedForm';
// import label from '../../utils/lngEn';
import StudentAddDropContainer from './StudentAddDropContainer';
import { setCoursesToAdd } from '../../actions/general'
import { hasUnsavedChanges } from '../common/utils'

class GetStartedPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      run: {},
      student: {},
      studentLoaded: false
    };
    this.handleGetStartedFormSubmit = this.handleGetStartedFormSubmit.bind(this);
  }

  componentDidMount() {
    // ** if we are loading fresh we don't have run data, so get it
    if (!this.props.run.id) this.props.runActions.getRun();

    this.props.studentActions.getStudent()
    

    // **if we are loading fresh, we haven't set coursesToAdd yet
    // ** otherwise, courseToAdd will persist the data we are CURRENTLY working with
    if (!this.props.coursesToAdd.length) {
      this.props.coursesActions.getAllCourses().then(() => {
        if (!this.props.run.assignment_complete) {
          this.props.runActions.getAllRankPreferences().then(() => {
            const currentCourses = this.props.student.preferences.map(p => this.props.courses.find(c => c.id === p.course))
            this.props.setCoursesToAdd(currentCourses)
          });
        }
      });
    }
    
  }

  // @HACK - for some reason student above comes back as id "" so I have to leave this in
  componentWillReceiveProps(nextProps) {
    if (nextProps.student.id) {
      this.setState({ student: nextProps.student, studentLoaded: true });
    }
  }

  handleGetStartedFormSubmit(values) {
    this.setState({ studentLoaded: false });
    let obj = {
      target_course_units: +values.target_course_units,
      max_course_units: +values.max_course_units
    };
    this.props.studentActions.setTarget(obj);
  }

  render() {
    const { run } = this.props;
    const { assignment_complete, allow_students_min_change, allow_students_max_change } = run;

    const creditFormDisabled = !allow_students_min_change && !allow_students_max_change

    if (assignment_complete) {
      return <StudentAddDropContainer {...this.props} />;
    }

    this.state.studentLoaded && this.state.student.id
    return (
      <div>
        <Row>
          <Col md={12}>
            {this.props.run.id ? (
              <div>
                <StudentSteps active={0} />
                <Row>
                  <Col md={7}>
                    <div className="page-subtitle mt-0" style={{marginBottom: 10}}>{creditFormDisabled ? 'Get started' : 'How many credits do you need?'}</div>
                    <Row>
                      <Col md={7} className="mb-4">
                        {hasUnsavedChanges(this.props.student.preferences, this.props.coursesToAdd)
                          ? <Badge style={{ padding: '6px', backgroundColor: 'red' }}>Rankings not yet saved</Badge>
                          : null
                        }
                      </Col>
                    </Row>
                    {!this.props.run.is_eliciting ? (
                      this.props.run.ranking_session_not_open_text != null ? (
                        <p className="lead" dangerouslySetInnerHTML={{__html: this.props.run.ranking_session_not_open_text
                          .replace('[[[primary_contact_email]]]',
                            `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)}}>
                        </p>
                      ) : (
                        ''
                      )
                    ) : (
                      <div>
                        {this.props.run.additional_student_text != null ? (
                          <p className="lead" dangerouslySetInnerHTML={{__html: this.props.run.additional_student_text
                            .replace('[[[primary_contact_email]]]',
                              `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)}}>
                          </p>
                        ) : (
                          ''
                        )}
                          { creditFormDisabled
                              ? null
                              : this.state.studentLoaded && this.state.student.id ? (
                                  <GetStartedForm
                                    onSubmit={this.handleGetStartedFormSubmit}
                                    initialValues={{
                                      target_course_units: this.state.student.target_course_units,
                                      max_course_units: this.state.student.max_course_units
                                    }}
                                    progress={this.state.submittingRunFormProgress}
                                    allow_min={this.props.run.allow_students_min_change}
                                    allow_max={this.props.run.allow_students_max_change}
                                    primary_contact={this.props.run.primary_contact}
                                  />
                                ) : (
                                  <div className="spinner-box">
                                    <Spinner spinnerName="three-bounce" className="mt-4" />
                                  </div>
                                )}
                      </div>
                    )}
                  </Col>
                  <Col md={3}>
                    {this.props.run.is_eliciting ? (
                      <div className=" text-center">
                        <Link
                          to={`/rank/${localStorage.getItem('run')}/find`}
                          className="btn btn-primary"
                          disabled={
                            !this.props.student.max_course_units
                          }
                          onClick={
                            (!this.props.student.max_course_units)
                              ? function(e) {
                                  e.preventDefault();
                                }
                              : null
                          }
                        >
                          Next: Find Classes
                        </Link>
                      </div>
                    ) : null}
                  </Col>
                </Row>
                
              </div>
            ) : (
              <div className="spinner-box">
                <Spinner spinnerName="three-bounce" className="mt-4" />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    coursesToAdd: state.general.coursesToAdd
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    coursesActions: bindActionCreators(coursesActions, dispatch),
    setCoursesToAdd: bindActionCreators(setCoursesToAdd, dispatch)

  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetStartedPage);



// WEBPACK FOOTER //
// ./src/components/rank/GetStartedPage.js